import { handleActions, combineActions } from 'redux-actions'
import { Map } from 'immutable'
import { Profile } from './models'
import * as actions from './actions'

const ignoreUndefined = (prev, next) => (typeof next !== 'undefined' ? next : prev)

export const profile = handleActions(
  {
    [combineActions(
      actions.fetchCurrentProfileStarted,
      actions.fetchCurrentProfileFailed,
      actions.receiveProfile,
    )]: (state, action) => state.setIn(['status', 'fetch'], action.type),

    [combineActions(
      actions.updateProfileStarted,
      actions.updateProfileFailed,
      actions.updateProfileSuccess,
    )]: (state, action) => state.setIn(['status', 'update'], action.type),

    [actions.receiveProfile]: (state, action) => {
      const { profile, visibility } = action.payload
      return state
        .updateIn(['data'], Profile(), data => data.mergeWith(ignoreUndefined, profile))
        .set('visibility', visibility)
    },

    [actions.setVisibilityStarted]: (state, action) => {
      return state.set('visibility', action.payload)
    },
  },
  Map(),
)

export const profileUI = handleActions(
  {
    [actions.setProfileUI]: (state, action) => {
      return state.updateIn(['data'], Profile(), data =>
        data.mergeWith(ignoreUndefined, action.payload),
      )
    },

    [actions.setProfileUIData]: (state, action) => {
      const { key, value } = action.payload
      return state.setIn(['data', key], value)
    },

    [combineActions(
      actions.checkUserHandleExistenceStarted,
      actions.receiveUserHandleExistence,
      actions.receiveUserGlobalHandleExistence,
    )]: (state, action) => {
      return state.setIn(['handle', 'status'], action.type)
    },

    [actions.receiveUserHandleExistence]: (state, action) => {
      return state.setIn(['valid', 'handle'], action.payload.valid)
    },

    [actions.receiveUserGlobalHandleExistence]: (state, action) => {
      return state.setIn(['valid', 'globalHandle'], action.payload.valid)
    },

    [actions.uploadCoverPhotoStarted]: (state, action) => {
      const oldCoverPhoto = state.getIn(['data', 'coverPhotoUrl'])
      return state
        .setIn(['data', 'coverPhotoUrl'], action.payload.file.preview)
        .setIn(['coverPhotoUpload', 'pending'], true)
        .setIn(['coverPhotoUpload', 'previousCoverPhoto'], oldCoverPhoto)
        .deleteIn(['coverPhotoUpload', 'error'])
    },

    [actions.clearCoverPhoto]: state => {
      return state.setIn(['data', 'coverPhotoUrl'], undefined)
    },

    [actions.uploadCoverPhotoSuccess]: (state, action) => {
      return state
        .setIn(['data', 'coverPhotoUrl'], action.payload.url)
        .setIn(['coverPhotoUpload', 'pending'], false)
        .deleteIn(['coverPhotoUpload', 'error'])
    },

    [actions.uploadCoverPhotoFailed]: (state, action) => {
      const previousCoverPhoto = state.getIn(['coverPhotoUpload', 'previousCoverPhoto'])
      return state
        .setIn(['data', 'coverPhotoUrl'], previousCoverPhoto)
        .setIn(['coverPhotoUpload', 'pending'], false)
        .setIn(['coverPhotoUpload', 'error'], action.payload)
    },
  },
  Map({ coverPhotoUpload: Map() }),
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/reducers.js